import { isMSTeams } from 'utils/MSTeams';

export const appendReferrer = (href: string, referrer: string): string => {
  const hashIdx = href.indexOf('#');
  const base = hashIdx === -1 ? href : href.slice(0, hashIdx);
  const hash = hashIdx === -1 ? '' : href.slice(hashIdx);

  const queryIdx = base.indexOf('?');
  const hasReferrer =
    queryIdx !== -1 &&
    base
      .slice(queryIdx + 1)
      .split('&')
      .some(param => param.startsWith('referrer='));

  if (hasReferrer) {
    return href;
  }

  const separator = queryIdx === -1 ? '?' : '&';

  return `${base}${separator}referrer=${encodeURIComponent(referrer)}${hash}`;
};

export const getFinalTarget = (href: string) => {
  if (href.startsWith('/') || isMSTeams()) {
    return undefined;
  }

  try {
    const sameOrigin = new URL(href).origin === window.location.origin;

    return sameOrigin ? undefined : '_blank';
  } catch (error) {
    return '_blank';
  }
};
